import { useEffect } from "react";

const SITE = "https://rbtun.no";

// Per-route title, description, canonical and og:url; restores the homepage values on unmount.
export const useSeo = ({ title, desc, path }) => {
  useEffect(() => {
    const prevTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content");
    const canon = document.querySelector('link[rel="canonical"]');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const ogDesc = document.querySelector('meta[property="og:description"]');
    const prevOgTitle = ogTitle?.getAttribute("content");
    const prevOgDesc = ogDesc?.getAttribute("content");
    document.title = title;
    meta?.setAttribute("content", desc);
    canon?.setAttribute("href", `${SITE}${path}`);
    ogUrl?.setAttribute("content", `${SITE}${path}`);
    ogTitle?.setAttribute("content", title);
    ogDesc?.setAttribute("content", desc);
    return () => {
      document.title = prevTitle;
      if (prevDesc) meta?.setAttribute("content", prevDesc);
      canon?.setAttribute("href", `${SITE}/`);
      ogUrl?.setAttribute("content", `${SITE}/`);
      if (prevOgTitle) ogTitle?.setAttribute("content", prevOgTitle);
      if (prevOgDesc) ogDesc?.setAttribute("content", prevOgDesc);
    };
  }, [title, desc, path]);
};

// Adds a JSON-LD <script> to <head> while the page is mounted.
export const useJsonLd = (id, obj) => {
  const json = obj ? JSON.stringify(obj) : "";
  useEffect(() => {
    if (!json) return undefined;
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.id = id;
    s.text = json;
    document.head.appendChild(s);
    return () => { s.remove(); };
  }, [id, json]);
};
